import * as types from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    isFetching: false,
    fetchSuccess: false,
    fetchFailed: false,
    start: 1,
    connectionList: [],
    mutualConnectionsModalInfo: {
        displayName: '',
        show: false,
        count: 0
    }
};

const mutualConnectionsFetching = (state, { reset }) => {
    return {
        ...state,
        isFetching: true,
        fetchFailed: false,
        fetchSuccess: false,
        connectionList: reset ? [] : state.connectionList,
        start: reset ? 1 : state.start
    };
};

const mutualConnectionsFinished = (isSuccess) => (state, { data, start }) => ({
    ...state,
    isFetching: false,
    fetchSuccess: isSuccess,
    fetchFailed: !isSuccess,
    connectionList: isSuccess ? state.connectionList.concat(data.profileList) : state.connectionList,
    start: isSuccess ? start : state.start
});

const resetMutualConnections = () => {
    return INITIAL_STATE;
};

const showMutualConnectionsModal = (state, action) => {
    const { displayName, show, count } = action.payload;
    return {
        ...state,
        mutualConnectionsModalInfo: {
            displayName,
            show,
            count
        }
    };
};

const handlers = {
    [types.FETCH_MUTUAL_CONNECTIONS_FETCHING]: mutualConnectionsFetching,
    [types.FETCH_MUTUAL_CONNECTIONS_SUCCESS]: mutualConnectionsFinished(true),
    [types.FETCH_MUTUAL_CONNECTIONS_FAIL]: mutualConnectionsFinished(false),
    [types.RESET_MUTUAL_CONNECTIONS]: resetMutualConnections,
    [types.SHOW_MUTUAL_CONNECTIONS_MODAL]: showMutualConnectionsModal
};

export const getMutualConnectionsModalInfo = (state) => state.mutualConnections.mutualConnectionsModalInfo;

export default function mutualConnections(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
